
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/addresses",
      function () {
        return require("private-next-pages/profile/addresses.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/addresses"])
      });
    }
  